import type { SxProps } from '@mui/material';
import type { ITheme } from '@mui/material/styles';

export const sx = <T extends Record<string, unknown>, P extends Record<string, SxProps>>(
  generator: (theme?: ITheme, props?: T) => P
) => {
  return (theme?: ITheme, props?: T) => {
    return generator(theme, props);
  };
};
